var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"placeholder":"选择","options":_vm.shu,"props":_vm.xiabiao,"filterable":"","clearable":_vm.clearable},on:{"change":_vm.Change},model:{value:(_vm.shuju),callback:function ($$v) {_vm.shuju=$$v},expression:"shuju"}})}
var staticRenderFns = []

export { render, staticRenderFns }